"use strict";

exports.topInt = 2147483647;
exports.bottomInt = -2147483648;

exports.topChar = String.fromCharCode(65535);
exports.bottomChar = String.fromCharCode(0);



//////////////////
// WEBPACK FOOTER
// ./output/Data.Bounded/foreign.js
// module id = 296
// module chunks = 0